import { createAction } from 'redux-actions';
export var createCallbackActionCreator = function (actionType) {
    return createAction(actionType, function (streamId) { return ({ streamId: streamId }); });
};
//# sourceMappingURL=helpers.js.map